import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

export const EmptyStateWrapper = styled("div")(() => ({
  minHeight: 550,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const ExpireLabel = styled("span")(({ expired }: { expired: boolean }) => ({
  color: expired ? colors.error600 : colors.gray600,
}));

export const ArchiveBadge = styled("div")(() => ({
  columnGap: "8px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  padding: "4px 8px",
  background: colors.gray100,
  borderRadius: "100px",
  "& span": {
    color: colors.gray600,
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
}));

export const UploadButtonInput = styled("input")(() => ({
  display: "none",
}));

type ClickableRowActionButtonProps = {
  disabled?: boolean;
};

export const ClickableRowActionButton = styled("div")(
  ({ disabled = false }: ClickableRowActionButtonProps) => ({
    cursor: disabled ? "not-allowed" : "pointer",
    marginLeft: "4px",
  })
);

export const ColumnDateShow = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const ColumnStatus = styled("div")(() => ({
  position: "relative",
  left: "-2px",
  "& > div": {
    width: "fit-content",
  },
}));

type ConfirmationModalBodyTextProps = {
  isError?: boolean;
};

export const ConfirmationModalBodyText = styled("span")(
  ({ isError }: ConfirmationModalBodyTextProps) => ({
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: 0.5,
    color: isError ? colors.error600 : colors.gray600,
    marginBottom: "8px",
  })
);

export const ConfirmationModalBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: colors.white,
}));

export const useStyles = makeStyles(() => ({
  modalFooter: {
    background: `${colors.white} !important`,
  },
}));
